import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { account } from './account.module';
import { users } from './users.module';
import { options } from './options.module';
import { industry } from './industry.module';
import { leadOwners } from './leadOwners.module';
import { salesFunnel } from './salesFunnel.module';
import { distributionCutoff } from './distributionCutoff.module';

Vue.use(Vuex);

export const store = new Vuex.Store({
  strict: true,
  modules: {
    alert,
    account,
    users,
    options,
    industry,
    leadOwners,
    salesFunnel,
    distributionCutoff
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js